import { MEASUREMENT_SYSTEM_METRIC, MEASUREMENT_SYSTEM_IMPERIAL, DIFFERENTIAL_PRESSURE_UNIT_PASCAL, DIFFERENTIAL_PRESSURE_UNIT_INCHES_OF_WATER } from 'services/UserPreferencesManager';

// TODO: point at the helpdesk article once it is published.
const VGB_LEARN_MORE_URL = 'https://support.disruptive-technologies.com/hc/en-us';

/* @ngInject */
export default class ProfileController {
    constructor(AuthService, UserPreferencesManager, $rootScope, FeatureFlags, VirtualGlycolBufferTemperatureVisibilityService, AnalyticsService, ToastService) {
        this.AuthService = AuthService;
        this.UserPreferencesManager = UserPreferencesManager;
        this.$rootScope = $rootScope;
        this.FeatureFlags = FeatureFlags;
        this.VirtualGlycolBufferTemperatureVisibilityService = VirtualGlycolBufferTemperatureVisibilityService;
        this.AnalyticsService = AnalyticsService;
        this.ToastService = ToastService;
    }

    $onInit() {
        const authData = this.AuthService.getAuthData();

        if (authData) {
            this.userProfile = authData.profile;
        }

        // Use the locally cached measurement system
        this.measurementSystem = this.UserPreferencesManager.getMeasurementSystem();
        this.metricValue = MEASUREMENT_SYSTEM_METRIC;
        this.imperialValue = MEASUREMENT_SYSTEM_IMPERIAL
        this.differentialPressureUnit = this.UserPreferencesManager.getDifferentialPressureUnit();
        this.pascalValue = DIFFERENTIAL_PRESSURE_UNIT_PASCAL;
        this.inchesOfWaterValue = DIFFERENTIAL_PRESSURE_UNIT_INCHES_OF_WATER;

        this.vgbIsBeta = true;
        this.vgbLearnMoreUrl = VGB_LEARN_MORE_URL;
        this.showVgbTemperatures = this.VirtualGlycolBufferTemperatureVisibilityService.showTemperatures;

        // Refresh the local cache, and update if it changed
        this.UserPreferencesManager.refresh()
            .then(() => {
                this.measurementSystem = this.UserPreferencesManager.getMeasurementSystem();
                this.differentialPressureUnit = this.UserPreferencesManager.getDifferentialPressureUnit();

                // The setting may have been changed from another browser
                const showVgbTemperatures = this.VirtualGlycolBufferTemperatureVisibilityService.showTemperatures;
                if (showVgbTemperatures !== this.showVgbTemperatures) {
                    this.showVgbTemperatures = showVgbTemperatures;
                    this.VirtualGlycolBufferTemperatureVisibilityService.notifyChanged();
                }
            })
    }

    // No page context in the profile popover, so gate on the flag alone.
    get vgbEnabled() {
        return this.FeatureFlags.isActive('sensor_virtual_glycol_buffer');
    }

    onMeasurementSystemChange() {
        this.UserPreferencesManager.setMeasurementSystem(this.measurementSystem)
    }

    onDifferentialPressureUnitChange() {
        this.UserPreferencesManager.setDifferentialPressureUnit(this.differentialPressureUnit)
    }

    onShowVgbTemperaturesChange() {
        const value = this.showVgbTemperatures;
        this.VirtualGlycolBufferTemperatureVisibilityService.setShowTemperatures(value)
            .then(() => {
                this.AnalyticsService.trackEvent(`vgb.profile.toggled_${value ? 'on' : 'off'}`);
                this.ToastService.showSimpleTranslated(value ? 'vgb_setting_shown' : 'vgb_setting_hidden');
            })
            .catch(() => {
                this.showVgbTemperatures = this.VirtualGlycolBufferTemperatureVisibilityService.showTemperatures;
                this.ToastService.showSimpleTranslated('vgb_setting_not_saved');
            });
    }

    signOut() {
        this.AuthService.signOut();
    }
}
